import { useState } from "react";
import axios from "axios";
import { Lock, ShieldCheck } from "lucide-react";
import { API } from "../../config";

export const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      onLogin(data.token);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-void px-4 font-body">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm rounded-3xl border border-ink/10 bg-surface p-8 shadow-2xl shadow-black/40"
      >
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-mint-dim">
            <Lock className="h-5 w-5 text-mint" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-ink">Lead Dashboard</h1>
            <p className="text-xs text-ink/50">CardConnect Commerce — owner access</p>
          </div>
        </div>
        <label htmlFor="admin-password" className="mb-2 block text-xs font-semibold uppercase tracking-wider text-ink/50">
          Password
        </label>
        <input
          id="admin-password"
          data-testid="admin-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
          autoComplete="current-password"
          placeholder="Enter admin password"
          className="w-full rounded-xl border border-ink/10 bg-elevated px-4 py-3.5 text-sm text-ink outline-none transition-colors placeholder:text-ink/35 focus:border-mint"
        />
        {error && (
          <p data-testid="admin-login-error" className="mt-3 text-sm text-danger">
            {error}
          </p>
        )}
        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={busy || !password}
          className="mt-5 flex w-full items-center justify-center gap-2 rounded-full bg-mint px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-mint-dark disabled:cursor-not-allowed disabled:opacity-50"
        >
          <ShieldCheck className="h-4 w-4" />
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
};
